// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){ 

	$(document).ready(function () {
		$('body.sitemap').attr('id','default');
				// Main Nav Dropdown
				$("#primary-nav li").hover(function(){
					$(this).addClass("hover");
					$('ul.submenu',this).fadeIn(200);
				}, function(){
					$(this).removeClass("hover");
					$('ul.submenu',this).fadeOut(200);
				});

		$(".burger").click(function() {
			$(this).toggleClass('active'); 
			$('#primary-nav').toggleClass('active');
		    return false;
		}); 
	}); 
 
}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}